import React, { useState, useEffect } from 'react';
import analyticsService from '../services/analyticsService';

const AnalyticsTest = () => {
  const [localEvents, setLocalEvents] = useState([]);
  const [userInfo, setUserInfo] = useState(null);

  useEffect(() => {
    loadLocalEvents();
  }, []);

  const loadLocalEvents = () => {
    const events = analyticsService.getLocalEvents();
    setLocalEvents(events);
    setUserInfo(analyticsService.userInfo);
  };

  const testPageView = () => {
    analyticsService.trackPageView('Test Page', '/test');
    loadLocalEvents();
  };

  const testCarListingAction = () => {
    analyticsService.trackCarListingAction('car_added_to_my_cars', 'test-car-123', {
      dealerId: 'test-dealer-123',
      carRegistrationNumber: 'KA01AB1234',
      carMake: 'Toyota',
      carModel: 'Camry',
      carYear: 2020,
      carPrice: 500000
    });
    loadLocalEvents();
  };

  const clearEvents = () => {
    analyticsService.clearLocalEvents();
    loadLocalEvents();
  };

  const setTestUser = () => {
    analyticsService.setUser({
      uid: 'test-user-123',
      email: 'test@example.com',
      displayName: 'Test User',
      roles: ['orguserdealer'],
      organization: 'Test Org',
      dealerId: 'test-dealer-123'
    });
    loadLocalEvents();
  };

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h2>Dealer Analytics Test Component</h2>
      
      <div style={{ marginBottom: '20px' }}>
        <h3>User Info</h3>
        <pre>{JSON.stringify(userInfo, null, 2)}</pre>
      </div>

      <div style={{ marginBottom: '20px' }}>
        <h3>Actions</h3>
        <button onClick={setTestUser} style={{ margin: '5px' }}>Set Test User</button>
        <button onClick={testPageView} style={{ margin: '5px' }}>Test Page View</button>
        <button onClick={testCarListingAction} style={{ margin: '5px' }}>Test Car Listing Action</button>
        <button onClick={clearEvents} style={{ margin: '5px' }}>Clear Events</button>
        <button onClick={loadLocalEvents} style={{ margin: '5px' }}>Refresh</button>
      </div>

      <div>
        <h3>Local Events ({localEvents.length})</h3>
        <pre style={{ maxHeight: '400px', overflow: 'auto', backgroundColor: '#f5f5f5', padding: '10px' }}>
          {JSON.stringify(localEvents, null, 2)}
        </pre>
      </div>
    </div>
  );
};

export default AnalyticsTest;
